import { render } from "./lists.vue?vue&type=template&id=31d72082"
import script from "./lists.js?vue&type=script&lang=js"
export * from "./lists.js?vue&type=script&lang=js"

import "./lists.vue?vue&type=style&index=0&id=31d72082&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__